import gql from 'graphql-tag'

export default gql`
query listUsersGridView($filter: UserFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listUsers(filter: $filter, params: $params) {
			items {
				id
				name
				code
				printName
			}
			cursors {
				hasNext
				hasPrevious
				before
				after
			}
			hasNextPage
			total
		}
	}
}
`
